import { useEffect, useRef, useState } from 'react';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { toast } from 'react-toastify';
import { useUser } from '../Context';
import { auth, db } from '../Firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import Loading from './Loading';
import eye from "../Assets/eye.png"
import eyebrow from "../Assets/eyebrow.png"
import groupImage from "../Assets/6736833_3374375.png"
import graph from "../Assets/graph7.png"

export default function SignIn() {
    const navigate = useNavigate()
    const { user, loading, setLoading, setUser } = useUser()
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [visiblePassword, setVisiblePassword] = useState(false);
    const emailInputRef = useRef(null);
    const passwordInputRef = useRef(null);
    useEffect(() => {
        if (user) {
            console.log(user)
            navigate('/');
            toast.error("Already signed in.");
            return;
        }
    }, [user])

    const handleSignIn = async (e) => {
        e.preventDefault()
        emailInputRef.current.blur();
        passwordInputRef.current.blur();
        if (!email || !password) {
            toast.warn("Please fill all the details.");
            return;
        }
        try {
            setLoading(true)
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            console.log(user)
            if (user) {
                try {
                    const docRef = await getDoc(doc(db, "lessee", user.uid));
                    if (docRef.exists()) {
                        const docRefData = docRef.data();
                        console.log("doc ref data is: ", docRefData.adminAuthorization)
                        if (docRefData.adminAuthorization) {
                            console.log(docRefData)
                            setUser({ uid: user.uid, ...docRefData });
                            toast.success(`Welcome, ${docRefData.name}`)
                            navigate('/')
                        }
                        else {
                            toast.error("Admin authorization pending.")
                            await signOut(auth)
                        }
                    } else {
                        try {
                            const docRef = await getDoc(doc(db, "admin", user.uid));
                            if (docRef.exists()) {
                                const docRefData = docRef.data();
                                console.log(docRefData)
                                setUser({ admin: true, uid: user.uid, ...docRefData });
                                toast.success(`Welcome admin.us`)
                                navigate('/')
                            } else {
                                toast.error("User not found in database");
                            }
                        }
                        catch (error) {
                            console.log(error);
                        }
                    }
                }
                catch (error) {
                    console.log(error);
                }
                // navigate()
            }
        } catch (error) {
            console.error("Error signing up:", error.message);
            let errorMessage = error.message.split('auth/')[1].split(')')[0].split('-').join(" ");
            toast.warn(errorMessage);
        }
        setEmail("")
        setPassword("")
        setLoading(false)
    };

    return (
        <>
            {loading && <Loading />}
            <main className='w-screen px-24 h-[88vh] gap-12 flex items-center justify-between  bg-cover'>
                <img className='h-full p-28 bg-cover aspect-square object-contain' alt='hi' src={groupImage} style={{ backgroundImage: `url(${graph})` }} />
                <form className='flex flex-col gap-4 w-6/12 justify-center pb-24 rounded-lg h-full p-6 px-12'>
                    <h1 className='text-center w-fit text-[2.8rem] antialiased font-semibold text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text'>Sign In</h1>
                    <div className='border hover:shadow-lg focus-within:shadow-lg focus-within:scale-105  group p-3 py-0 rounded-xl transition-all duration-200 flex w-full gap-3 items-center'>
                        <h2 className=' text-blue-500'>Email:</h2>
                        <input ref={emailInputRef} className='outline-none w-full h-full px-2 py-4' type='email' placeholder='johndoe@gmail.com' onChange={((e) => setEmail(e.target.value))} value={email} />
                    </div>
                    <div className='border hover:shadow-lg focus-within:shadow-lg focus-within:scale-105  group p-3 py-0 rounded-xl transition-all duration-200 flex w-full gap-3 items-center'>
                        <h2 className=' text-blue-500'>Password:</h2>
                        <input ref={passwordInputRef} className='outline-none w-full h-full px-2 py-4' type={visiblePassword ? "text" : "password"} placeholder='John@Do3' onChange={((e) => setPassword(e.target.value))} value={password} />
                        {!visiblePassword ?
                            <img className='h-6 pr-2 cursor-pointer transition-all' src={eye} onClick={() => { setVisiblePassword(!visiblePassword) }} alt='eye' />
                            :
                            <img className='h-6 pr-2 cursor-pointer transition-all' src={eyebrow} onClick={() => { setVisiblePassword(!visiblePassword) }} alt='eye' />
                        }
                    </div>
                    <button type='submit' className='bg-gradient-to-tr hover:shadow-lg hover:shadow-gray-300 duration-200 from-sky-500 to-indigo-500 transition-all w-fit  px-6 text-lg rounded-md font-normal py-2 text-white' onClick={(e) => { handleSignIn(e) }}>Sign in</button>
                </form>
            </main>
        </>
    );
}
